export const getTextColor = (value: number) => {
  if (value < 60) {
    return spiColors.low;
  }
  if (value >= 60 && value < 80) {
    return spiColors.medium;
  }
  return spiColors.high;
};

export const spiColors = {
  low: '#C32828',
  medium: '#FFB800',
  high: '#409E59',
};
